import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "OverviewTabContent CountryTargetingContent" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "NoCountriesTargetedText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountriesPerLevel = _resolveComponent("CountriesPerLevel")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([
		'OverviewTab',
		_ctx.tabSelected ? 'Selected' : ''
	])
  }, [
    _createElementVNode("div", {
      class: "OverviewTabHeader",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOverallTab()))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "OverviewTabHeaderTitle" }, " Targeting per country ", -1 /* CACHED */)),
      _createTextVNode(" (" + _toDisplayString(_ctx.countryTargetingDetails) + ") ", 1 /* TEXT */),
      (_ctx.shouldPricingBeShown)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "OverviewTabHeaderTitle" }, " and pricing ", -1 /* CACHED */)),
            _createTextVNode(" (" + _toDisplayString(_ctx.pricingValue) + ") ", 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "lnr-chevron-right OverviewTabChevron" }, null, -1 /* CACHED */))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.premiumStates, (premium, level, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['TargetingTab', _ctx.selectedTargetingTab === index ? 'Selected' : '']),
          onClick: ($event: any) => (_ctx.setTargetingTab(index))
        }, [
          _createTextVNode(_toDisplayString(premium.name) + " ", 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass(["CountryIndicator", _ctx.numCountriesPerPremium[level] === 0 ? 'NoCountries' : ''])
          }, _toDisplayString(_ctx.numCountriesPerPremium[level]), 3 /* TEXT, CLASS */)
        ], 10 /* CLASS, PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_ctx.countriesOfSelectedTargetingTab.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " There are no countries with this targeting. "))
        : (_openBlock(), _createBlock(_component_CountriesPerLevel, {
            key: 1,
            level: _ctx.premiumStates[_ctx.selectedTargetingTab],
            countries: _ctx.countriesOfSelectedTargetingTab
          }, null, 8 /* PROPS */, ["level", "countries"]))
    ])
  ], 2 /* CLASS */))
}